import React from 'react';
import FormModal from '../../theme/modals/FormModal';
import validators from '../../../utils/forms/validators';
import formatters from '../../../utils/forms/formatters';
import * as preconfiguredInputs from '../../../utils/forms/preconfiguredInputs';
import { submitBid, updateBid, pullApplicationBids } from '../../../store/calls/applicationData';
import { toggleGlobalLoader } from '../../../store/actions/session';
import {
	addSuccessAlert,
	addErrorAlert,
} from '../../../store/calls/alertLoadingDispatch';

function ApplicationBidModal({
	application_id,
	productType,
	bidData,
	onCancel,
}) {
	// dif inputs for ppas and loans
	const getInputs = () => {
		if (productType === 'PPA') {
			return [
				{
					type: 'text',
					label: 'Rate',
					dataKey: 'rate',
					...validators.isNumberNotNull,
					// formatter: (val) => formatters.percentage.formatter(val, 2),
					otherInputs: [
						{
							type: 'select',
							label: 'Type',
							value: 'per_kwh',
							options: [
								{
									display: '¢ Per kWh',
									value: 'per_kwh',
								},
							],
							dataKey: 'rate_type',
						},
					],
				},
				{
					type: 'text',
					label: 'Term (in years)',
					dataKey: 'term',
					...validators.isNumberNotNull,
				},
				{
					type: 'text',
					label: 'Annual Riser (%)',
					subLabel: 'Fix an annual riser to the cost of kwh.',
					dataKey: 'annual_riser',
					...validators.isNumberNotNull,
				},
				{
					type: 'select',
					label: 'Is O&M Included?',
					dataKey: 'om_included',
					...preconfiguredInputs.nullBooleanSelect,
					...validators.exists,
				},
				{
					type: 'select',
					label: 'Is Insurance Included?',
					dataKey: 'insurance_included',
					...preconfiguredInputs.nullBooleanSelect,
					...validators.exists,
				},
				{
					type: 'textarea',
					label: 'Early Buyout Options',
					subLabel:
						'Please include any notes about early buyout options and their pricing methods',
					dataKey: 'buyout_option',
					...validators.exists,
				},
				{
					type: 'textarea',
					label: 'Conditions and Notes',
					subLabel:
						'Please include any notes about terms, special requirements, early buyouts, etc. Please note that any contact information or instances of your company name will be removed before display.',
					dataKey: 'conditions',
					...validators.exists,
				},
				{
					type: 'textarea',
					label: 'Notes for administrator.',
					subLabel:
						'Notes or comments for the CleanFi adminstrator who will approve your bid.',
					dataKey: 'admin_notes',
				},
			];
		}

		return [
			{
				type: 'text',
				label: 'Rate',
				dataKey: 'rate',
				...validators.isNumberNotNull,
				formatter: (val) => formatters.percentage.formatter(val, 2),
				defaultValue: 'fixed',
				otherInputs: [
					{
						type: 'select',
						label: 'Type',
						options: [
							{
								display: '% Fixed',
								value: 'fixed',
							},
							{
								display: '% + 5yr T-bill',
								value: 'float_w_5yr',
							},
							{
								display: '% + 7yr T-bill',
								value: 'float_w_7yr',
							},
							{
								display: '% + 10yr T-bill',
								value: 'float_w_10yr',
							},
							{
								display: '% + 20yr T-bill',
								value: 'float_w_20yr',
							},
							{
								display: '% + 30yr T-bill',
								value: 'float_w_30yr',
							},
						],
						dataKey: 'rate_type',
					},
				],
			},
			{
				type: 'text',
				label: 'Term (in years)',
				dataKey: 'term',
				...validators.isNumberNotNull,
			},
			{
				type: 'text',
				label: 'Annual Riser (%)',
				subLabel: 'Fix an annual riser to the cost of kwh.',
				dataKey: 'annual_riser',
				formatter: (val) => formatters.percentage.formatter(val, 2),
				...validators.isNumberNotNull,
			},
			{
				type: 'select',
				label: 'Is O&M Included?',
				dataKey: 'om_included',
				...preconfiguredInputs.nullBooleanSelect,
				...validators.exists,
			},
			{
				type: 'select',
				label: 'Is Insurance Included?',
				dataKey: 'insurance_included',
				...preconfiguredInputs.nullBooleanSelect,
				...validators.exists,
			},
			{
				type: 'textarea',
				label: 'Early Buyout Options',
				subLabel:
					'Please include any notes about early buyout options and their pricing methods',
				dataKey: 'buyout_option',
				...validators.exists,
			},
			{
				type: 'textarea',
				label: 'Conditions and Notes',
				subLabel:
					'Please include any notes about terms, special requirements, early buyouts, etc.',
				dataKey: 'conditions',
			},
		];
	};

	// populate inputs with data from props.bidData if it exists
	const getPopulatedInputs = () => {
		let inputs = getInputs();
		if (bidData) {
			inputs = inputs.map((d) => {
				if (bidData[d.dataKey]) {
					d.value = bidData[d.dataKey];
				}
				return d;
			});
		}
		return inputs;
	};

	return (
		<FormModal
			title="Submit a Bid"
			onCancel={onCancel}
			inputs={getPopulatedInputs()}
			visible
			onSubmit={async (data) => {
				toggleGlobalLoader(true);
				try {
					let res;
					if (bidData?.id) {
						res = await updateBid(application_id, { ...bidData, ...data });
					} else {
						res = await submitBid(application_id, data);
					}
					console.log('SUCCESS', res);
					await pullApplicationBids(application_id);
					toggleGlobalLoader(false);
					addSuccessAlert('Bid submitted successfully.');
					onCancel();
				} catch (err) {
					console.error(err);
					toggleGlobalLoader(false);
					addErrorAlert('Bid submission failed.');
				}
			}}
		/>
	);
}

export default ApplicationBidModal;
